const attachmentUploadStrings = {
  fileLabel: "Velg fil",
  uploadButton: "Last opp",
  fileEmptyError: "Kan ikke laste opp tom fil",
  fileTooLargeError: "Filen er for stor for opplasting, max {0} MB",
  permittedFileTypesInfoText: "Tillatte filtyper: BMP, JPG, PNG, GIF, PDF"
};

export default attachmentUploadStrings;